import { cloneDeep, isEqual, omit } from "lodash";
import { actionTypes } from "redux-query";
import { DimensionSelectorEntityType } from "components/modal/widget-workshop/types";
export const datapointsKey = "PostDatapoints";
export const SectionlessRequests = "_";
const excludeRequestsFromBatch = [
    "CustomFundsGrid",
    "CustomManagersGrid",
    "CustomAssetsGrid",
    "CustomPortfolioGrid"
];
const omitedFieldsForComparison = ["id", "requests"];
const waitTimer = 10;
const isIterable = (obj) => (obj ? typeof obj[Symbol.iterator] === "function" : false);
/*
 * The purpose of this method is to split the requests to datapoints into two separate ones:
 * The first request with assets/instruments data,
 * The second request handles all other data.
 */
const hasAssetsOrInstruments = (request) => {
    const requests = request?.body?.requests;
    const allMeasures = requests?.flatMap((x) => x.measures)?.map((x) => x?.datapoint?.standard || x?.datapoint.custom) || [];
    const allDimensions = requests?.flatMap((x) => x.dimensions)?.map((x) => x?.datapoint?.standard || x?.datapoint.custom) || [];
    if (allMeasures.concat(allDimensions).some((x) => x?.startsWith(DimensionSelectorEntityType.Asset) || x?.startsWith(DimensionSelectorEntityType.Instrument))) {
        return true;
    }
    return false;
};
const compareRequest = (firstAction, secondAction) => isEqual(omit(firstAction.body, omitedFieldsForComparison), omit(secondAction.body, omitedFieldsForComparison)) && hasAssetsOrInstruments(firstAction) === hasAssetsOrInstruments(secondAction) && firstAction?.body?.id !== secondAction?.body?.id;
const compareRequestIds = (acc, action) => acc.includes(action);
const shouldExcludeFromBatching = (action) => {
    const requestId = action?.body?.requests?.[0]?.id;
    return excludeRequestsFromBatch.includes(requestId);
};
export const isPostDatapointsRequest = (action) => action.type === actionTypes.REQUEST_ASYNC && action.queryKey?.includes(datapointsKey) &&
    !action?.body?.id?.startsWith(SectionlessRequests);
let requestsInProgress = [];
let flushTimeout = null;
const flushRequests = (next) => {
    const requestsToFlush = requestsInProgress;
    flushTimeout = null;
    requestsInProgress = [];
    requestsToFlush.forEach((requestInProgress) => next(requestInProgress.request));
};
const groupRequests = (action, next) => {
    let grouped = false;
    if (shouldExcludeFromBatching(action)) {
        next(action);
        return;
    }
    if (requestsInProgress.length === 0 && !flushTimeout) {
        flushTimeout = setTimeout(() => {
            flushRequests(next);
        }, waitTimer);
    }
    requestsInProgress.forEach((requestInProgress) => {
        if (compareRequest(requestInProgress.request, action) &&
            isIterable(requestInProgress.request.body?.requests) &&
            isIterable(action.body?.requests)) {
            if (!compareRequestIds(requestInProgress.accumulated, action.body?.id)) {
                requestInProgress.accumulated.push(action.body.id);
                requestInProgress.request.queryKey = `${datapointsKey}-${requestInProgress.accumulated.sort().join("-")}`;
                requestInProgress.request.body.requests = [
                    ...requestInProgress.request.body.requests,
                    ...action.body.requests
                ];
            }
            grouped = true;
        }
    });
    if (!grouped && action?.body?.id) {
        requestsInProgress.push({
            accumulated: [action.body.id],
            request: cloneDeep(action)
        });
    }
};
export const groupDatapointsMiddleware = () => (next) => (action) => (isPostDatapointsRequest(action)
    ? groupRequests(action, next)
    : next(action));
